import { JobAd, JobAdIntegrationDetails } from "./common";

export interface JobAdCreated {
  jobAd: JobAd;
}

export interface JobAdEdited {
  id: string;
  jobAd: JobAd;
}

export interface JobAdIntegrationPayload {
  integrationDetails: JobAdIntegrationDetails;
}

export interface JobAdPublished {
  id: string;
}

export interface JobAdReOpened {
  id: string;
}

export enum JobAdEventName {
  JobAdCreated = "jobAdNew",
  JobAdEdited = "jobAdChanged",
  JobAdPublished = "jobAdPublished",
  JobAdClosed = "jobAdClosed",
  JobAdReOpened = "jbAdReOpen",
}
